<div class="title">
  <div matDialogTitle>Anteckning</div>
  <spb-kalp-type-indicator [type]="data.logType"/>

  <div class="log-type">
    @if (data.logType === 'occupation') {
      Anställningsform
    } @else if (data.logType === 'oldProperty') {
      Existerande bostad
    } @else if (data.logType === 'income') {
      Inkomstkontroll
    } @else if (data.logType === 'ucThreshold') {
      UC lägre än {{ ucLowestThreshold | number }} kr
    } @else if (data.logType === 'propertyLoansMatchingUC') {
      Bostadslån är avvikande mot UC
    } @else if (data.logType === 'blancoLoansThreshold') {
      Privatlån överskriver {{ blancoHighestThreshold | number }} kr
    } @else if (data.logType === 'blancoLoansMatchingUC') {
      Privatlån är avvikande mot UC
    } @else if (data.logType === 'retiredCheck') {
      Pension måste styrkas
    }
  </div>
</div>
<div class="content">
  @if (resolvable) {
    <mat-checkbox [formControl]="resolved">
      Markera som löst?
    </mat-checkbox>
  }
  <mat-form-field [style.width.px]="490">
      <textarea
        [formControl]="notes"
        cdkAutosizeMaxRows="5"
        cdkAutosizeMinRows="5"
        cdkTextareaAutosize
        matInput
      ></textarea>
  </mat-form-field>
</div>
<mat-dialog-actions>
  <div class="buttons">
    <button matButton="outlined" matDialogClose="null">Avbryt</button>
    <button (click)="save()" [disabled]="notes.invalid"
            matButton="filled">Spara
    </button>
  </div>
</mat-dialog-actions>
